var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCadenas = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "22.39 13.72 44.8 56.96",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67.19,70.68H22.39V25.88h44.8v44.8ZM24.85,68.22h39.88V28.34H24.85v39.88Z",
    fill: "#0c0e1b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6,28.34h-23.63v-14.62h23.63v14.62ZM35.43,25.88h18.71v-9.7h-18.71v9.7Z",
    fill: "#0c0e1b",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 44.42,
    cy: 41.47,
    r: 5.81,
    fill: "#0c0e1b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44.42 41.47 35.93 59.46 53.65 59.46 44.42 41.47",
    fill: "#0c0e1b",
    strokeWidth: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCadenas);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Cadenas.d973d8b7b07ae61f0bb7c8bcb439f4e0.svg";